import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-option-pick-placeholder',
    template: `
        <div class="option-pick">
            <div class="option-indicator">
                @if (isEpcotEnabled) {
                    <vn-icon name="theme-locked" size="16" />
                }
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './option-pick-placeholder.component.scss',
    imports: [IconCustomComponent],
})
export class OptionPickPlaceholderComponent {
    private epcotConfig = inject(EpcotConfig);

    @HostBinding('class.empty-offline-odd')
    get applyEmptyOfflineClass(): boolean {
        return this.isEpcotEnabled;
    }

    isEpcotEnabled = this.epcotConfig.isEnabled;
}
